<template>
  <v-card class="mb-1" :class="selectedClass">
    <v-card-actions>
      <v-btn text @click="selectedContainer">{{ container.name }}</v-btn>
      <v-spacer/>
      <container-form
        edit
        :key="'edit' + storage + container.name"
        :storage="storage"
        :container="container.name"
        :azureName="container.azureName"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on">
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit {{ container.name }}</span>
        </v-tooltip>
      </container-form>
      <container-form
        :key="'copy' + storage + container.name"
        :storage="storage"
        :container="container.name"
        :azureName="container.azureName"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on">
              mdi-content-copy
            </v-icon>
          </template>
          <span>Copy {{ container.name }}</span>
        </v-tooltip>
      </container-form>
      <container-confirm-delete :storage="storage" :container="container">
        <v-icon color="red">
          mdi-trash-can
        </v-icon>
      </container-confirm-delete>
    </v-card-actions>
  </v-card>
</template>
<script>
import ContainerConfirmDelete from './ContainerConfirmDelete.vue';
import ContainerForm from './ContainerForm.vue';

export default {
  name: 'ContainerCard',
  components: {ContainerForm, ContainerConfirmDelete},
  data() {
    return {
      show: false
    };
  },
  computed: {
    selectedClass() {
      return this.isSelected ? 'grey lighten-2' : '';
    }
  },
  props: {
    container: {
      type: Object,
      required: true
    },
    storage: {
      type: String,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    selectedContainer() {
      this.$emit('selected', this.container);
    }
  }
};
</script>
